import { NO_VALUE_DISPLAY } from "@ryde/shared";

import { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvJsonCellTransformer = (): {
  getJsonArrayValue: CsvCellTransformerFn;
  getJsonValue: CsvCellTransformerFn;
} => {
  const getJsonArrayValue = ({ value }: ICsvColumnTransformer): string => {
    const items = value as unknown[] | undefined;

    if (!Array.isArray(items) || !items.length) {
      return NO_VALUE_DISPLAY;
    }

    return JSON.stringify(items);
  };

  const getJsonValue = ({ value }: ICsvColumnTransformer): string => {
    if (!value) {
      return NO_VALUE_DISPLAY;
    }

    return JSON.stringify(value);
  };

  return { getJsonArrayValue, getJsonValue };
};
